export const LOAN_INPUT_QUESTION = 'How much are you actually looking to borrow?'
